export const RUBRIC_PICKER_CONSTS = {
    rubricMsg: 'Рубрика',
    subrubricMsg: 'Подрубрика'
}
